import { CheckIcon } from "lucide-react";
import * as React from "react";
import { useSelector } from "react-redux";
import { formatWithComma } from "../../../utils/subscription";
import { Mixpanel } from "../../../config/Mixpanel";
import Constants from "../../../common/constants";

// Main Frame Component
const benefits = [
  "LinkedIn Endorsement & Recommendation Letter",
  "Unlimited Free Certificates (Skill & Micro-skill)",
  "Mock Interviews To Refine Your Skills",
];

const ChooseNextJob = ({razorpayMainHandler , handleOnboardingCompletion}) => {
  const [selectedOption, setSelectedOption] = React.useState("premium");
  const maxProduct = useSelector(state => state?.onBoarding?.maxProduct);

  console.log(selectedOption)

  return (
    <div className="flex flex-col bg-[#406AFF]/5 w-[calc(100%+24px)] -ml-[12px] items-start justify-center gap-6 px-4 py-8 relative bg-[#406aff0d]">
      <header className="w-full flex flex-col items-center gap-1 relative self-stretch w-full flex-[0_0_auto]">
        <p className="relative flex items-center justify-center w-fit mt-[-1.00px] [font-family:'Inter',Helvetica] font-normal text-[#ffffff80] text-base tracking-[0] leading-4 whitespace-nowrap">
          Your Next Step to Stand Out
        </p>

        <h1 className="relative flex items-center justify-center [font-family:'Inter',Helvetica] font-semibold text-white text-[24px] text-center tracking-[0] leading-[31.2px]">
          Choose What Gets You Hired
        </h1>
      </header>

      <div className="w-full flex flex-col  items-start gap-4 relative flex-[0_0_auto]">
        <div className="flex flex-col items-start gap-3 relative self-stretch w-full flex-[0_0_auto]">
          <div className="relative w-full h-auto">
            <div className={`flex flex-col w-full items-start gap-8 p-5  bg-[#406aff26] rounded-2xl ${selectedOption === "premium" ? "border-[0.7px] border-solid border-[#7fc241]" : ""}`} onClick={() => setSelectedOption("premium")}>
              <div className="p-0 w-full">
                <div className="flex flex-col gap-8">
                  <div className="flex items-center justify-between relative self-stretch w-full ">
                    <div className="inline-flex flex-col items-start justify-center gap-[7px] relative">
                      <span className="relative  mt-[-1.00px] [font-family:'Inter',Helvetica] font-semibold text-white text-lg tracking-[-0.18px] leading-[23.4px]">
                      100% Job Preparation Support
                      </span>

                      <div className="inline-flex items-center gap-1 relative flex-[0_0_auto]">
                        <span className="mt-[-1.00px] font-semibold text-[#2bbd13] text-base tracking-[-0.16px] leading-4 relative w-fit [font-family:'Inter',Helvetica] ">
                          ₹{formatWithComma(maxProduct?.cost)}
                        </span>

                        <span className="font-normal text-[#e06064] text-xs tracking-[-0.12px] leading-3 line-through relative w-fit [font-family:'Inter',Helvetica]">
                          ₹{formatWithComma(maxProduct?.["pp_original_cost"])}
                        </span>
                      </div>
                    </div>

                    <div className="w-5 h-5 p-1 rounded-full border-2 border-[#7FC241] flex flex-shrink-0 items-center justify-center">
                    {selectedOption === "premium" && (
                      <div className="w-full h-full rounded-full bg-[#7FC241]"></div>
                    )}
                  </div>
                  </div>

                  <div className="inline-flex flex-col items-start gap-3 relative flex-[0_0_auto]">
                    <h3 className="relative w-fit mt-[-1.00px] [font-family:'Inter',Helvetica] font-semibold text-[#70aeff] text-sm tracking-[-0.14px] leading-[18.2px] whitespace-nowrap">
                    Additional Features Including
                    </h3>

                    <ul className="inline-flex flex-col items-start gap-4 relative flex-[0_0_auto]">
                      {benefits?.map((benefit, index) => (
                        <li
                          key={index}
                          className="inline-flex items-center gap-2 relative flex-[0_0_auto]"
                        >
                          <CheckIcon className="relative w-4 h-4 bg-[#2BBD13] rounded-full flex items-center justify-center p-[2px]" />

                          <span className="relative w-fit mt-[-1.00px] [font-family:'Inter',Helvetica] font-normal text-white text-xs tracking-[-0.12px] leading-[15.6px]">
                            {benefit}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="h-[22px] items-center gap-2.5 px-2 py-1 absolute -top-2 right-4 rounded-3xl inline-flex justify-center border-0" style={{ background: 'linear-gradient(to right, #2BBD13 0%, #192E42 100%)' }}>
              <span className="relative w-fit [font-family:'Inter',Helvetica] font-medium text-white text-xs tracking-[-0.12px] leading-[15.6px] whitespace-nowrap">
                Best Value
              </span>
            </div>
          </div>

          <label
            className={`flex items-center justify-around gap-2 p-5 relative self-stretch w-full flex-[0_0_auto] bg-[#83beff1a] rounded-xl border-0 cursor-pointer ${selectedOption === "free" ? "border-[0.7px] border-solid border-[#7fc241]" : ""}`}
            onClick={() => setSelectedOption("free")}
          >
            <div className="p-0 w-full">
              <div className="flex items-center justify-between relative">
                <div className="flex flex-col items-start gap-2 relative justify-center">
                  <span className="relative mt-[-1.00px] [font-family:'Inter',Helvetica] font-semibold text-white text-base tracking-[-0.16px] leading-4 ">
                  Job Readiness Score
                  </span>

                  <div className="flex flex-col items-center gap-1 relative">
                    <span className="relative w-fit mt-[-1.00px] [font-family:'Inter',Helvetica] font-normal text-[#ffffffb2] text-sm tracking-[-0.14px] leading-[14px] whitespace-nowrap">
                      Free
                    </span>
                  </div>
                </div>

                <div className="flex items-center gap-2 relative flex-[0_0_auto]">
                  <span className="relative [font-family:'Inter',Helvetica] font-medium text-[#e06064] text-xs tracking-[-0.12px] leading-[15.6px]">
                    No Certificate
                  </span>

                  <div className="w-5 h-5 p-1 rounded-full border-2 border-[#7FC241] flex items-center justify-center">
                    {selectedOption === "free" && (
                      <div className="w-full h-full rounded-full bg-[#7FC241]"></div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </label>
        </div>

        <button className="flex h-[52px] items-center justify-center gap-2.5 px-[90px] py-3 relative self-stretch w-full bg-[#7fc241] rounded-lg shadow-[0px_0px_10px_#7fc24159] hover:bg-[#7fc241]/90 border-0 cursor-pointer" onClick={() => {
          if(selectedOption === "premium"){
            Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_JOB_PAGE_START_MY_JOB_PREP_NOW_BUTTON_CLICKED);
            Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_PREMIUM_BUTTONS_CLICKED);
            razorpayMainHandler(maxProduct?.id , ()=>{})
          }else{
            Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_JOB_PAGE_SEE_MY_JOB_READINESS_SCORE_BUTTON_CLICKED);
            handleOnboardingCompletion()
          }
        }}>
          <div className="inline-flex flex-col items-center justify-center gap-1 relative flex-[0_0_auto] mt-[-5.00px] mb-[-5.00px]">
            <span className="relative flex items-center justify-center w-fit mt-[-1.00px] [font-family:'Inter',Helvetica] font-semibold text-[#121212] text-base text-center tracking-[0] leading-[normal] whitespace-nowrap">
            {selectedOption === "premium" ? "Start My Job Prep. Now!" : "See My Job Readiness Score"}
            </span>

            {selectedOption === "premium" ? <p className="relative flex items-center justify-center w-fit [font-family:'Inter',Helvetica] font-normal text-transparent text-xs text-center tracking-[0] leading-[normal]">
              <span className="font-medium text-[#121212b2]">
                Early Bird Discount:{" "}
              </span>

              <span className="font-semibold text-[#121212b2]">₹{formatWithComma(maxProduct?.cost)}</span>

              <span className="font-medium text-[#121212b2]">&nbsp;</span>

              <span className="font-medium text-[#e06064] line-through">
                ₹{formatWithComma(maxProduct?.["pp_original_cost"])}
              </span>
            </p> : <p className="relative flex items-center text-[#121212b2] justify-center w-fit [font-family:'Inter',Helvetica] font-semibold text-xs text-center tracking-[0] leading-[normal]">Slow Track - No Job Support*</p>}
          </div>
        </button>
      </div>
    </div>
  );
};

export default ChooseNextJob